var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurvey = function SvgSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#E7E7E7",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    y: 9,
    fill: "#93278F",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 9,
    fill: "#E6E6E6",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 9,
    y: 9,
    fill: "#E6E6E6",
    rx: 2
  }))));
};
export default SvgSurvey;